{
	"dbAiFirstCreation": "aifc_create_enabled_ga"
}
